import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לקרוא לפחד בשם",
    opening: localizedGenderNode(
      [
      "היום אני לא מכריח את עצמי להחליט. אני רק מודה: אני מפחד/ת לעזוב."
    ],
      [
      "היום אני לא מכריח את עצמי להחליט. אני רק מודה: אני מפחד/ת לעזוב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “הפחד כאן כדי להגן עליי, לא כדי לנהל אותי.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “הפחד כאן כדי להגן עליי, לא כדי לנהל אותי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה בדיוק מפחיד אותי בלחשוב על עזיבה?\n[כאן אני כותב]",
      "מה הדבר שאני אומר/ת לעצמי כדי לא לגעת בפחד הזה?\n[כאן אני כותב]",
      "איפה בגוף הפחד מורגש עכשיו?\n[כאן אני כותב]"
    ],
      [
      "מה בדיוק מפחיד אותי בלחשוב על עזיבה?\n[כאן אני כותב]",
      "מה הדבר שאני אומר/ת לעצמי כדי לא לגעת בפחד הזה?\n[כאן אני כותב]",
      "איפה בגוף הפחד מורגש עכשיו?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לפחד יש קול. היום אני שומע/ת אותו בלי לציית לו."
    ],
      [
      "סגירה",
      "לפחד יש קול. היום אני שומע/ת אותו בלי לציית לו."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה מחשבה על עזיבה — נשימה אחת + משפט: “אני רק מקשיב/ה עכשיו.”",
      "כשעולה מחשבה על עזיבה — נשימה אחת + משפט: “אני רק מקשיב/ה עכשיו.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה לא טוב בקשר (בלי הצדקות)",
    opening: localizedGenderNode(
      [
      "היום אני רואה את המציאות כמו שהיא, בלי לרכך ובלי להקצין."
    ],
      [
      "היום אני רואה את המציאות כמו שהיא, בלי לרכך ובלי להקצין."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אמת לא רוצהת דרמה.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אמת לא רוצהת דרמה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "שלושה דברים שלא טובים לי בקשר הזה:\n[כאן אני כותב]",
      "איך כל אחד מהם משפיע עליי רגשית?\n[כאן אני כותב]",
      "מה אני מרוויח/ה מלהקטין את זה?\n[כאן אני כותב]"
    ],
      [
      "שלושה דברים שלא טובים לי בקשר הזה:\n[כאן אני כותב]",
      "איך כל אחד מהם משפיע עליי רגשית?\n[כאן אני כותב]",
      "מה אני מרוויח/ה מלהקטין את זה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לראות אמת זה לא בגידה. זה כבוד עצמי."
    ],
      [
      "סגירה",
      "לראות אמת זה לא בגידה. זה כבוד עצמי."
    ]
    ),
    action: localizedGenderNode(
      "אני לא מצדיק/ה היום התנהגות אחת שפוגעת בי (רק שם לב).",
      "אני לא מצדיק/ה היום התנהגות אחת שפוגעת בי (רק שם לב)."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "מה כן מחזיק אותי שם",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת לא מה רע — אלא מה מחזיק."
    ],
      [
      "היום אני בודק/ת לא מה רע — אלא מה מחזיק."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה גורם לי להישאר? (פחד לבד / תקווה / אשמה / הרגל / תלות)\n[כאן אני כותב]",
      "מה אני מפחד/ת שיקרה אם אעזוב?\n[כאן אני כותב]",
      "איזה חלק בי זקוק לביטחון עכשיו?\n[כאן אני כותב]"
    ],
      [
      "מה גורם לי להישאר? (פחד לבד / תקווה / אשמה / הרגל / תלות)\n[כאן אני כותב]",
      "מה אני מפחד/ת שיקרה אם אעזוב?\n[כאן אני כותב]",
      "איזה חלק בי זקוק לביטחון עכשיו?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אם משהו מחזיק אותי — הוא בוחר/ת שיראו אותו."
    ],
      [
      "סגירה",
      "אם משהו מחזיק אותי — הוא בוחר/ת שיראו אותו."
    ]
    ),
    action: localizedGenderNode(
      "אני נותן/ת שם אחד למה שמחזיק אותי — בלי שיפוט.",
      "אני נותן/ת שם אחד למה שמחזיק אותי — בלי שיפוט."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "הפחד מלהיות לבד",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בפחד בלי לברוח ממנו."
    ],
      [
      "היום אני נוגע/ת בפחד בלי לברוח ממנו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “בדידות היא תחושה, לא גזירת גורל.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “בדידות היא תחושה, לא גזירת גורל.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הדימוי הכי מפחיד שלי לגבי להיות לבד?\n[כאן אני כותב]",
      "מתי כבר הייתי לבד — ושרדתי?\n[כאן אני כותב]",
      "איזו אמת אחת קיימת גם אם הפחד חזק?\n[כאן אני כותב]"
    ],
      [
      "מה הדימוי הכי מפחיד שלי לגבי להיות לבד?\n[כאן אני כותב]",
      "מתי כבר הייתי לבד — ושרדתי?\n[כאן אני כותב]",
      "איזו אמת אחת קיימת גם אם הפחד חזק?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הפחד לא מספר את כל הסיפור."
    ],
      [
      "סגירה",
      "הפחד לא מספר את כל הסיפור."
    ]
    ),
    action: localizedGenderNode(
      "5 דקות לבד מודעת (בלי מסך) — רק להיות.",
      "5 דקות לבד מודעת (בלי מסך) — רק להיות."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "אשמה ואחריות",
    opening: localizedGenderNode(
      [
      "היום אני מבדיל/ה בין אשמה לאחריות."
    ],
      [
      "היום אני מבדיל/ה בין אשמה לאחריות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "על מה אני מרגיש/ה אשם/ה כשאני חושב/ת על עזיבה?\n[כאן אני כותב]",
      "מה באמת באחריותי — ומה לא?\n[כאן אני כותב]",
      "איך נראית אחריות בלי להלקות את עצמי?\n[כאן אני כותב]"
    ],
      [
      "על מה אני מרגיש/ה אשם/ה כשאני חושב/ת על עזיבה?\n[כאן אני כותב]",
      "מה באמת באחריותי — ומה לא?\n[כאן אני כותב]",
      "איך נראית אחריות בלי להלקות את עצמי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אחריות לא דורשת שאקריב את עצמי."
    ],
      [
      "סגירה",
      "אחריות לא דורשת שאקריב את עצמי."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה אשמה — אני אומר/ת: “זה רגש, לא פסק דין.”",
      "כשעולה אשמה — אני אומר/ת: “זה רגש, לא פסק דין.”"
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "תקווה שלא מתגשמת",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת אם אני חי/ה על עתיד דמיוני."
    ],
      [
      "היום אני בודק/ת אם אני חי/ה על עתיד דמיוני."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "לאיזה שינוי אני מחכה כבר הרבה זמן?\n[כאן אני כותב]",
      "מה המציאות הראתה לי עד עכשיו?\n[כאן אני כותב]",
      "איך זה מרגיש בגוף להחזיק תקווה שלא מתממשת?\n[כאן אני כותב]"
    ],
      [
      "לאיזה שינוי אני מחכה כבר הרבה זמן?\n[כאן אני כותב]",
      "מה המציאות הראתה לי עד עכשיו?\n[כאן אני כותב]",
      "איך זה מרגיש בגוף להחזיק תקווה שלא מתממשת?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "תקווה שלא זזה — שואבת אנרגיה."
    ],
      [
      "סגירה",
      "תקווה שלא זזה — שואבת אנרגיה."
    ]
    ),
    action: localizedGenderNode(
      "אני מבחין/ה היום בין “מה שקורה” ל“מה שהייתי רוצה”.",
      "אני מבחין/ה היום בין “מה שקורה” ל“מה שהייתי רוצה”."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "הערך שלי בתוך הקשר",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך הקשר משפיע על הערך העצמי שלי."
    ],
      [
      "היום אני בודק/ת איך הקשר משפיע על הערך העצמי שלי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך אני מרגיש/ה לגבי עצמי בתוך הקשר הזה?\n[כאן אני כותב]",
      "מה קורה לביטחון שלי כשיש קונפליקט?\n[כאן אני כותב]",
      "איזו גרסה שלי הייתה רוצה יותר כבוד?\n[כאן אני כותב]"
    ],
      [
      "איך אני מרגיש/ה לגבי עצמי בתוך הקשר הזה?\n[כאן אני כותב]",
      "מה קורה לביטחון שלי כשיש קונפליקט?\n[כאן אני כותב]",
      "איזו גרסה שלי הייתה רוצה יותר כבוד?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "קשר לא אמור להקטין אותי."
    ],
      [
      "סגירה",
      "קשר לא אמור להקטין אותי."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד של כבוד עצמי שאני שומר/ת איתי היום.",
      "משפט אחד של כבוד עצמי שאני שומר/ת איתי היום."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "מה הגוף כבר יודע",
    opening: localizedGenderNode(
      [
      "הגוף שלי יודע לפני הראש."
    ],
      [
      "הגוף שלי יודע לפני הראש."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך הגוף מגיב כשאני מדמיין/ת להישאר?\n[כאן אני כותב]",
      "איך הגוף מגיב כשאני מדמיין/ת לעזוב?\n[כאן אני כותב]",
      "מה ההבדל ביניהם?\n[כאן אני כותב]"
    ],
      [
      "איך הגוף מגיב כשאני מדמיין/ת להישאר?\n[כאן אני כותב]",
      "איך הגוף מגיב כשאני מדמיין/ת לעזוב?\n[כאן אני כותב]",
      "מה ההבדל ביניהם?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הגוף לא משקר — הוא מאותת."
    ],
      [
      "סגירה",
      "הגוף לא משקר — הוא מאותת."
    ]
    ),
    action: localizedGenderNode(
      "יד על חזה/בטן + נשימה אחת כשעולה בלבול.",
      "יד על חזה/בטן + נשימה אחת כשעולה בלבול."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "פחד מטעויות",
    opening: localizedGenderNode(
      [
      "היום אני משחרר/ת את הצורך בהחלטה מושלמת."
    ],
      [
      "היום אני משחרר/ת את הצורך בהחלטה מושלמת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מפחד/ת לטעות בו?\n[כאן אני כותב]",
      "האם אי־בחירה היא גם בחירה?\n[כאן אני כותב]",
      "מה המחיר של להישאר בלי לבחור?\n[כאן אני כותב]"
    ],
      [
      "מה אני מפחד/ת לטעות בו?\n[כאן אני כותב]",
      "האם אי־בחירה היא גם בחירה?\n[כאן אני כותב]",
      "מה המחיר של להישאר בלי לבחור?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אין החלטה בלי סיכון — אבל יש אמת."
    ],
      [
      "סגירה",
      "אין החלטה בלי סיכון — אבל יש אמת."
    ]
    ),
    action: localizedGenderNode(
      "אני מפסיק/ה היום לדרוש מעצמי ודאות.",
      "אני מפסיק/ה היום לדרוש מעצמי ודאות."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "גבולות שלא קיימים",
    opening: localizedGenderNode(
      [
      "היום אני רואה איפה אין לי גבול."
    ],
      [
      "היום אני רואה איפה אין לי גבול."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני מוותר/ת על עצמי שוב ושוב?\n[כאן אני כותב]",
      "מה הגבול שהייתי רוצה לשים — ולא שם?\n[כאן אני כותב]",
      "מה הפחד סביב הגבול הזה?\n[כאן אני כותב]"
    ],
      [
      "איפה אני מוותר/ת על עצמי שוב ושוב?\n[כאן אני כותב]",
      "מה הגבול שהייתי רוצה לשים — ולא שם?\n[כאן אני כותב]",
      "מה הפחד סביב הגבול הזה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "בלי גבולות — הפחד גדל."
    ],
      [
      "סגירה",
      "בלי גבולות — הפחד גדל."
    ]
    ),
    action: localizedGenderNode(
      "גבול פנימי אחד קטן רק לעצמי (גם בלי להגיד).",
      "גבול פנימי אחד קטן רק לעצמי (גם בלי להגיד)."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "מי אני בלי הקשר",
    opening: localizedGenderNode(
      [
      "היום אני זוכר/ת שאני יותר מהקשר."
    ],
      [
      "היום אני זוכר/ת שאני יותר מהקשר."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מי הייתי לפני הקשר הזה?\n[כאן אני כותב]",
      "איזה חלק בי נעלם עם הזמן?\n[כאן אני כותב]",
      "מה אני מתגעגע/ת אליו בעצמי?\n[כאן אני כותב]"
    ],
      [
      "מי הייתי לפני הקשר הזה?\n[כאן אני כותב]",
      "איזה חלק בי נעלם עם הזמן?\n[כאן אני כותב]",
      "מה אני מתגעגע/ת אליו בעצמי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא נעלם/ת בלי קשר."
    ],
      [
      "סגירה",
      "אני לא נעלם/ת בלי קשר."
    ]
    ),
    action: localizedGenderNode(
      "פעולה אחת שמחברת אותי לעצמי בלבד.",
      "פעולה אחת שמחברת אותי לעצמי בלבד."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "שיחה פנימית אמיתית",
    opening: localizedGenderNode(
      [
      "היום אני מדבר/ת עם עצמי בכנות."
    ],
      [
      "היום אני מדבר/ת עם עצמי בכנות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אם לא הייתי מפחד/ת — מה הייתי מודה בפני עצמי?\n[כאן אני כותב]",
      "מה אני בוחר/ת/ה עכשיו יותר מהכול?\n[כאן אני כותב]",
      "מה אני לא מוכן/ה להמשיך לשלם?\n[כאן אני כותב]"
    ],
      [
      "אם לא הייתי מפחד/ת — מה הייתי מודה בפני עצמי?\n[כאן אני כותב]",
      "מה אני בוחר/ת/ה עכשיו יותר מהכול?\n[כאן אני כותב]",
      "מה אני לא מוכן/ה להמשיך לשלם?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "האמת לא צורחת. היא שקטה."
    ],
      [
      "סגירה",
      "האמת לא צורחת. היא שקטה."
    ]
    ),
    action: localizedGenderNode(
      "אני נותן/ת לאמת להיות בלי לפעול.",
      "אני נותן/ת לאמת להיות בלי לפעול."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "לאן אני הולך/ת",
    opening: localizedGenderNode(
      [
      "היום אני מביט/ה קדימה — לא כדי לברוח, אלא כדי לכוון."
    ],
      [
      "היום אני מביט/ה קדימה — לא כדי לברוח, אלא כדי לכוון."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך הייתי רוצה להרגיש בקשר עתידי?\n[כאן אני כותב]",
      "איזה ערך אני לא מוכן/ה לוותר עליו יותר?\n[כאן אני כותב]",
      "מה צעד אחד קטן מקרב אותי לשם?\n[כאן אני כותב]"
    ],
      [
      "איך הייתי רוצה להרגיש בקשר עתידי?\n[כאן אני כותב]",
      "איזה ערך אני לא מוכן/ה לוותר עליו יותר?\n[כאן אני כותב]",
      "מה צעד אחד קטן מקרב אותי לשם?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "כיוון מתחיל בכוונה, לא בהחלטה."
    ],
      [
      "סגירה",
      "כיוון מתחיל בכוונה, לא בהחלטה."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת ערך אחד ומחזיק/ה בו השבוע.",
      "אני כותב/ת ערך אחד ומחזיק/ה בו השבוע."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה (להישאר נאמן/ה לעצמי)",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת בי — גם אם עוד אין החלטה."
    ],
      [
      "היום אני בוחר/ת בי — גם אם עוד אין החלטה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על עצמי במסע הזה?\n[כאן אני כותב]",
      "מה ברור לי יותר עכשיו, גם אם כואב?\n[כאן אני כותב]",
      "משפט חזרה לימים של בלבול:\n[כאן אני כותב]"
    ],
      [
      "מה למדתי על עצמי במסע הזה?\n[כאן אני כותב]",
      "מה ברור לי יותר עכשיו, גם אם כואב?\n[כאן אני כותב]",
      "משפט חזרה לימים של בלבול:\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "אני לא רוצה/ת לדעת הכול עכשיו.",
      "אבל אני כן יודע/ת דבר אחד:",
      "אני ראוי/ה לקשר שלא מפחיד אותי להיות אני.",
      "וזה כוח."
    ],
      [
      "סגירה סופית למסע",
      "אני לא רוצה/ת לדעת הכול עכשיו.",
      "אבל אני כן יודע/ת דבר אחד:",
      "אני ראוי/ה לקשר שלא מפחיד אותי להיות אני.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "פעולה אחת שמכבדת אותי — כאן ועכשיו.",
      "פעולה אחת שמכבדת אותי — כאן ועכשיו."
    ),
  },
].map(buildNormalizedDay);

export const fearLeavingBadRelationshipBlueprintHe = buildNormalizedPilotBlueprint({
  id: "fear_leaving_bad_relationship_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "fear_leaving_bad_relationship",
  category: "general",
  journeyName: {
    he: "פחד לעזוב קשר לא טוב",
    en: "Fear of Leaving an Unhealthy Relationship",
    es: "Miedo a dejar una relación dañina",
  },
  days,
});

export default fearLeavingBadRelationshipBlueprintHe;
